export enum FunctionCodeLabel {
  Corporate = 'Corporate',
  BillTo = 'Bill-To',
  PickupDelivery = 'Pickup & Delivery',
}
